export default __webpack_public_path__ + "static/media/logo4.ced5a814.jpg";